export default class UnknownError extends Error {
  constructor() {
    super();
    this.name = 'UnknownError';
    this.message = 'Não foi possível completar a ação';
  }
}
